/**
* @summary - Component that Provides Asset Category Listing Page
* @author Aro J
* @since 2024-08-13
*/
import React, { useState, useEffect } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import CustomAgGrid from '../commoncomponents/CustomAgGrid';
import CustomDialog from '../commoncomponents/CustomDialog';
import { useNavigate } from 'react-router-dom';
import { DefaultCard } from '../../assets/styled-components/card';
import { getAuthToken, getFacilityId, getcompanyId } from "../../utility/tokenUtility";
import axios from "axios";
import CreateNewButton from '../commoncomponents/CreateNewButton';
import RefreshExportButtons from '../commoncomponents/RefreshExportButtons';
import { MasterGraph, FemsGraph } from '../../utility/apiURLS';
import CloseButton from '../commoncomponents/CloseButton';
import HomeIconButton from '../commoncomponents/HomeIconButton';
import PageTitle from "../commoncomponents/PageTitle";
import SectionTitle from '../commoncomponents/SectionTitle';
import CreateNewBtn from "../commoncomponents/CreateNewBtn";
import { useAccess } from "../../AccessContext";
import utilities from '../../utility/utilities';

const columns = [
  { field: 'referenceno', headerName: 'Reference No' },
  { field: 'femtechnicalcategory', headerName: 'Category' },
  { field: 'technicaltype', headerName: 'Type' },
  { field: 'description', headerName: 'Description' },
];
const ListFemsDrawing = () => {
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [rowToDelete, setRowToDelete] = useState(null);
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [deletedRowDetails, setDeletedRowDetails] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const [gridApi, setGridApi] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  
  const accessData = useAccess();
  const access = utilities.getScreenPermissions(accessData, "ENGT006");
  const [filterModel, setFilterModel] = useState([]);
  const [sortModel, setSortModel] = useState([]);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [rowCount, setRowCount] = useState(0);
  const [exportData, setExportData] = useState([]);
  const [exportCount, setExportCount] = useState(0)

  const token = getAuthToken("id_token");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const facilityId = getFacilityId();
const femtechnicaldrawingId = getcompanyId();
  // const fetchtechdrawing = async () => {
  //   setIsLoading(true);
  //   try {
  //     if (femtechnicaldrawingId !== '00000000-0000-0000-0000-000000000000') {
  //       const response = await axios.get(`${FemsGraph}/api/graph/GetFemsTechDrawingbyFacilityId/${facilityId}?size=1000`, config);
  //       console.log("rep", response.data);
  //       setRows(response?.data); // Set the response data to the rows state
  //       setFilteredRows(response?.data); // Set the filtered data
  //     }
  //    } catch (error) {
  //     console.error("Error fetching Fems Technical Drawing:", error);
  //   }
  //   finally{
  //     setIsLoading(false);
  //   }
  // };
 

  const fetchtechdrawing = async () => {
    setIsLoading(true);
    try {
      if (femtechnicaldrawingId !== '00000000-0000-0000-0000-000000000000') {
        const response = await axios.get(`${FemsGraph}/api/graph/GetFemsTechDrawingbyFacilityId/${facilityId}?page=${pageIndex}&size=${pageSize}&filterOptions=${JSON.stringify(
        filterModel
      )}&sortOptions=${JSON.stringify(sortModel)}`, config);
  
        // Remove duplicate entries based on a unique field (e.g., referenceno)
        const uniqueData = Array.from(new Map(response.data.items.map(item => [item.referenceno, item])).values());
  
        setRows(uniqueData); // Set the unique data to rows
        setFilteredRows(uniqueData); // Set the unique data to filteredRows
        setRowCount(response.data.totalCount);
        setExportCount(response.data.totalCount)
  
      }
    } catch (error) {
      console.error("Error fetching Fems Technical Drawing:", error);
    } finally {
      setIsLoading(false);
    }
  };


  const fetchExportdata = async () => {
  
    try {
      if (femtechnicaldrawingId !== '00000000-0000-0000-0000-000000000000') {
        const response = await axios.get(`${FemsGraph}/api/graph/GetExportDataTechnical/${facilityId}?filterOptions=${JSON.stringify(
        filterModel
      )}&sortOptions=${JSON.stringify(sortModel)}`, config);

        setExportData(response.data)
  
      }
    } catch (error) {
      console.error("Error fetching Fems Technical Drawing:", error);
    } 
  };
  
  useEffect(() => {
    fetchtechdrawing();
  }, [filterModel, sortModel, pageIndex, pageSize]);

  const handleDelete = (row) => {
    setRowToDelete(row);
    setDeleteDialogOpen(true);
  };

  const confirmDelete = async () => {
    if (rowToDelete) {
      const token = getAuthToken("id_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const isDeleted = await deleteAssetCategory(rowToDelete.id, rowToDelete.femtechnicaldrawingId, config);
      setDeleteDialogOpen(false);
      if (isDeleted) {
        setDeletedRowDetails({ code: rowToDelete.assetcategory, desc: rowToDelete.assetcategorydesc });
        setConfirmationDialogOpen(true);
      }
      setRowToDelete(null);
    }
  };

  const deleteAssetCategory = async (id, femtechnicaldrawingId, config) => {
    try {
      // First API call to delete the Fems Technical Drawing
      if (femtechnicaldrawingId == '00000000-0000-0000-0000-000000000000') {
        await axios.delete(`${FemsGraph}/api/femtechnicaldrawings/${id}`, config);
      } else {
        await axios.delete(`${FemsGraph}/api/femtechnicaldrawings/${id}`, config);
        await axios.delete(`${FemsGraph}/api/femtechnicaldrawingattachments/${femtechnicaldrawingId}`, config);

      }


      fetchtechdrawing();

      return true;
    } catch (error) {
      console.error("Error deleting Fems Technical Drawing:", error);

      // Handle specific error conditions
      if (error.response && error.response.status === 400) {
        setErrorMessage("Record cannot be deleted as it is referred in another record.");
      } else {
        setErrorMessage("An error occurred while deleting the Fems Technical Drawing. Please try again.");
      }

      return false;
    }
  };




  const handleCreateClick = () => {
    navigate("/femsdrawing/register");
  };


  const handleEdit = (rowData) => {
    console.log(rowData)
    navigate("register", { state: { ...rowData, readOnlyEdit: true, mode: 'edit' } });
  };


  const handleView = (rowData) => {
    navigate("register", { state: { ...rowData, readOnly: true, mode: 'view' } });
  };

  const handleRefresh = () => {
    setPageIndex(1);
    setPageSize(10);
    setFilterModel([])
    setSortModel([])
  };

  return (
    <>
      <PageTitle title={"FEMS Technical Drawing"} />
      <DefaultCard>
        <Stack
          mb={1}
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <SectionTitle title={"FEMS Technical Drawing List"} />

          <Stack direction={"row"} spacing={1.5}>
            {access?.canCreate && <CreateNewBtn onClick={handleCreateClick} />}
            <RefreshExportButtons
              exportFunction={fetchExportdata}
              exportData={exportData}
              refData={gridApi}
              handleRefresh={handleRefresh}
              title={"FEMS Technical Drawing"}
            />
          </Stack>
        </Stack>
        <Box>
          <CustomAgGrid
            rows={filteredRows}
            columns={columns}
            handleEdit={access?.canEdit && handleEdit}
            handleDelete={access?.canDelete && handleDelete}
            handleView={access?.canView && handleView}
            setGridApi={setGridApi}
            isLoading={isLoading}
            pagination={false}
            setFilterModel={setFilterModel}
            setSortModel={setSortModel}
            totalCount={rowCount}
            pageIndex={pageIndex}
            pageSize={pageSize}
            setPageIndex={setPageIndex}
            setPageSize={setPageSize}
          />
        </Box>

        <CustomDialog
          open={deleteDialogOpen}
          onClose={() => setDeleteDialogOpen(false)}
          onConfirm={confirmDelete}

          content="Are you sure you want to delete?"
          cancelBtn='No'
          confirmBtn="Yes"
        />
        <CustomDialog
          open={confirmationDialogOpen}
          onClose={() => setConfirmationDialogOpen(false)}

          content="Record deleted successfully."
          confirmBtn="OK"
          onConfirm={() => setConfirmationDialogOpen(false)}
        />
        <CustomDialog
          open={!!errorMessage}
          onClose={() => setErrorMessage("")}
          onConfirm={() => setErrorMessage("")}
          content={errorMessage}
          confirmBtn="Ok"
        />
      </DefaultCard>
      <CloseButton />
    </>
  );
};

export default ListFemsDrawing;

